export const BOSS_MAX_HP = 1000;

export const CORE_PHASES = {
  CONTAINMENT: 'containment',
  FRACTURE: 'fracture',
  EMERGENCE: 'emergence',
  EVOLUTION: 'evolution',
  MELTDOWN: 'meltdown',
};

export const CORE_PHASE_ORDER = Object.values(CORE_PHASES);
export const CORE_PHASE_RANK = Object.fromEntries(
  CORE_PHASE_ORDER.map((phase, index) => [phase, index])
);

export const getCorePhaseForHp = (hp) => {
  // A lethal hit does not trigger a transformation the Core never survives.
  if (hp <= 0) return CORE_PHASES.CONTAINMENT;
  if (hp <= 200) return CORE_PHASES.MELTDOWN;
  if (hp <= 400) return CORE_PHASES.EVOLUTION;
  if (hp <= 600) return CORE_PHASES.EMERGENCE;
  if (hp <= 800) return CORE_PHASES.FRACTURE;
  return CORE_PHASES.CONTAINMENT;
};

const unit = (value) => Math.max(0, Math.min(1, value));

// Continuous values let an impact blend smoothly between any two forms.
export const getCoreVisualState = (level) => {
  const fracture = unit(level);
  const emergence = unit(level - 1);
  const evolution = unit(level - 2);
  const meltdown = unit(level - 3);
  return {
    fracture,
    emergence,
    evolution,
    meltdown,
    heart: emergence * 0.45 + evolution * 0.55,
    shellOpenness:
      fracture * 0.2 + emergence * 0.35 + evolution * 0.45 + meltdown * 0.25,
  };
};
